import React, { useLayoutEffect, useRef } from 'react';

import Icon from 'components/shared/Icon/Icon';
import Button from 'components/shared/Button/Button';
import Loader from 'components/shared/Loader/Loader';
import Typography from 'components/shared/Typography/Typography';

const LoadingWrapper = ({ children, isLoading, error, retry, id, hideError = false }) => {
  const formRef = useRef(null);
  const lastHeightRef = useRef(0);

  useLayoutEffect(() => {
    if (formRef.current) lastHeightRef.current = formRef.current.offsetHeight;
  });

  if (!!error && hideError) {
    return <div aria-hidden="true" style={{ height: lastHeightRef.current }} />;
  }

  if (!!error) {
    const message = typeof error === 'string' ? error : error?.error;

    return (
      <div className="flex h-full w-full animate-enter-up flex-col items-center justify-center gap-2 p-6">
        <Icon icon="illustration-payment-failed" />
        <Typography variant="p" size="medium" weight="medium">
          Something went wrong
        </Typography>
        <Typography variant="p" color="neutral-600" size="small" className="text-center">
          {message || 'Please try again.'}
        </Typography>
        <Button onClick={retry} text="Retry" size="small" icon="refresh-linear" iconColor="white" />
      </div>
    );
  }

  return (
    <div ref={formRef} className="relative w-full animate-enter-up" aria-busy={isLoading} id={id}>
      {isLoading && (
        <div
          role="status"
          aria-live="polite"
          aria-label="Loading"
          className="pointer-events-auto absolute inset-0 z-10 flex items-center justify-center rounded-md bg-white/50">
          <Loader color="primary" size={40} />
        </div>
      )}
      {children}
    </div>
  );
};

export default LoadingWrapper;
